import { all, takeEvery, call, put } from 'redux-saga/effects';
import * as ACTION from './addContactOptionActionTypes';
import { getContactLimit, getUserPolicy, getInsuranceCompany } from './addContactOptionsServices';
import { getContactLimitFailure, getContactLimitSuccess, getInsuranceCompanyOptionsFailure, getInsuranceCompanyOptionsSuccess, getUserPolicyOptionsFailure, getUserPolicyOptionsSuccess } from './addContactOptionsAction';

function* addContactOptionWatcher() {
    yield takeEvery(ACTION.GET_CONTACT_LIMIT,getLeadSource);
    yield takeEvery(ACTION.GET_POLICY_OPTION,getUserPolicySaga);
    yield takeEvery(ACTION.GET_INSURANCE_COMPANIES_OPTION,getInsuranceCompanySaga);
}

function* getLeadSource(action) {
    const { payload } = action;
    try {
       const response = yield call(getContactLimit, payload);
        if (response.data.success && response.data.data) {
            yield put(getContactLimitSuccess(response.data.data));
        }else{
            yield put(getContactLimitFailure());
        }
    } catch (error) {
        yield put(getContactLimitFailure());
    }
}

function* getUserPolicySaga(action) {
    const { payload } = action;
    try {
       const response = yield call(getUserPolicy, payload);
        if (response.success && response.data) {
            yield put(getUserPolicyOptionsSuccess(response.data));
        }else{
            yield put(getUserPolicyOptionsFailure());
        }
    } catch (error) {
        yield put(getUserPolicyOptionsFailure());
    }
}

function* getInsuranceCompanySaga(action) {
    const { payload } = action;
    try {
       const response = yield call(getInsuranceCompany, payload);
        if (response.success && response.data) {
            yield put(getInsuranceCompanyOptionsSuccess(response.data));
        }else{
            yield put(getInsuranceCompanyOptionsFailure());
        }
    } catch (error) {
        yield put(getInsuranceCompanyOptionsFailure());
    }
}

export default function* addContactOptionMiddleware() {
    yield all([
        addContactOptionWatcher()
    ])
}